<template>
  <div>
    <div class="row">
      <div class="col-12">
        <button class="btn btn-primary float-right" v-on:click="refresh">Mettre à jour</button>
        <p style="padding: 8px 8px 0 0;" class="text-muted float-right">
          <small><em>Mise-à-jour automatique dans {{countdown}} secondes</em></small>
        </p>
      </div>
      <div class="col-sm-6 graph-box">
        <OnProgresTexte :data="data.compte_par_etat"></OnProgresTexte>
      </div>
      <div class="col-sm-6 graph-box">
        <SoumissionParStatut :data="data.soumission_par_statut"></SoumissionParStatut>
      </div>

      <div class="col-sm-6 graph-box">
        <SommeDesStatuts :data="data.statut_plan"></SommeDesStatuts>
      </div>

      <div class="col-sm-6 graph-box">
        <OnInactivetimeDevPlans :data="data.dev_age"></OnInactivetimeDevPlans>
      </div>

    </div>
  </div>
</template>

<script>
import OnInactivetimeDevPlans from '@/components/OnInactivetimeDevPlans.vue';
import SommeDesStatuts from '@/components/SommeDesStatuts.vue';
import OnProgresTexte from '@/components/OnProgresTexte.vue';
import SoumissionParStatut from '@/components/SoumissionParStatut.vue';
import axios from 'axios';

export default {
  name: 'OnTdb',
  data: function() {return {
    countdown: 59,
    data: {
      compte_par_etat: {},
      statut_plan: [],
      dev_age:[],
      soumission_par_statut: {}
    }
  }},

  components: {
    OnInactivetimeDevPlans,
    SommeDesStatuts,
    OnProgresTexte,
    SoumissionParStatut
  },
  methods: {
    intervalExpiry() {
      this.countdown--;
      if(this.countdown==0) {
        this.refresh();
        this.countdown=59;
      }
    },
    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/on/dashboard_stats.php',
          { })
        .then(response => (this.data = response.data))
    }
  },
  mounted () {
    this.refresh();
    this.polling = setInterval(function () {
      this.intervalExpiry();
    }.bind(this), 1000);
  },
  beforeDestroy () {
    clearInterval(this.polling)
  }
}
</script>

<style>
</style>
